'use client';

import { c as _c } from "react/compiler-runtime";
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import Check from '../../icons/Check';
import { cn } from '../../utils/cn';
const checkboxVariants = cva('', {
  variants: {
    // Keep selector prefixes literal: Tailwind's scanner cannot see composed class names.
    state: {
      radix: 'border-border bg-input border data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=checked]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive-foreground aria-invalid:border-destructive peer size-5 shrink-0 transition-shadow outline-none focus-visible:ring-[2px] disabled:cursor-not-allowed disabled:opacity-50',
      native: 'border-border bg-input border peer-checked:bg-primary peer-checked:text-primary-foreground peer-checked:border-primary peer-focus-visible:border-ring peer-focus-visible:ring-ring/50 size-5 shrink-0 transition-shadow outline-none peer-focus-visible:ring-[2px]'
    },
    variant: {
      square: 'rounded-[3px]',
      circle: 'rounded-full'
    }
  },
  defaultVariants: {
    state: 'radix',
    variant: 'square'
  }
});
type CheckboxProps = React.ComponentProps<typeof CheckboxPrimitive.Root> & Omit<VariantProps<typeof checkboxVariants>, 'state'>;
function Checkbox(t0) {
  const $ = _c(11);
  let className;
  let props;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      variant,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = variant;
  } else {
    className = $[1];
    props = $[2];
    variant = $[3];
  }
  let t1;
  if ($[4] !== className || $[5] !== variant) {
    t1 = cn(checkboxVariants({
      variant,
      className
    }));
    $[4] = className;
    $[5] = variant;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CheckboxPrimitive.Indicator data-slot="checkbox-indicator" className="flex items-center justify-center text-current transition-none"><Check className="size-3.5" /></CheckboxPrimitive.Indicator>;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== t1) {
    t3 = <CheckboxPrimitive.Root data-slot="checkbox" className={t1} {...props}>{t2}</CheckboxPrimitive.Root>;
    $[8] = props;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
export { Checkbox, checkboxVariants };